export const PetsConfig = {
  types: {
    dog: 'DOG',
    cat: 'CAT',
  },
};
